import { render, staticRenderFns } from "./alphabet-pagination.vue?vue&type=template&id=60c321c8&scoped=true"
import script from "./alphabet-pagination.vue?vue&type=script&lang=js"
export * from "./alphabet-pagination.vue?vue&type=script&lang=js"
import style0 from "./alphabet-pagination.vue?vue&type=style&index=0&id=60c321c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c321c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c321c8')) {
      api.createRecord('60c321c8', component.options)
    } else {
      api.reload('60c321c8', component.options)
    }
    module.hot.accept("./alphabet-pagination.vue?vue&type=template&id=60c321c8&scoped=true", function () {
      api.rerender('60c321c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/pagination/alphabet-pagination.vue"
export default component.exports